<template>
  <div class="home">

   <div class="home-ct">
	   <el-row>
		
			   <div class="cart">
			   		<div>
			   			<el-row class="cart-tit">
							<el-col span="12">product </el-col>
							<el-col span="6"> quantity</el-col>
							<el-col span="6">sbutotal</el-col>
						</el-row>
			   		
			   					</div>
			   					<div>
			   						<ul>
			   							<li v-for="item in roll" class="cart-con">
											<el-row>
												<el-col span="1">
													<img @click="bit(item)" src="../../assets/arr.png" />
													</el-col>
													<el-col span="4">
															<img class="cart-img" :src="item.image" />
														</el-col>
														<el-col span="7">
															{{item.title}}
															</el-col>
												<el-col span="6"> <el-input-number size="mini"  v-model="item.num" @change="handleChange(item.num,item.inventoryId)" :min="1" :max="10" ></el-input-number></el-col>
												<el-col span="6">$ {{item.num*item.price_sale}}</el-col>
											</el-row>
			   							
											
			   							</li>
										
			   						
			   					</ul>
			   					</div>
			   					
			   					<div class="cart-bot">
			   						<div class="l1">
			   							<h4>SUBTOTAL:</h4>
			   							<h4>$ {{price}}</h4>
			   						</div>
			   						<div class="l2">
			   						
			   							<router-link to="/product/order"><div class="h-button cart-but">PROCEED TO CHECKOUT</div></router-link>
			   						</div>
			   					</div>
			   		   
			   </div>
		   
		 
	   </el-row>
	
	
   </div>
    </div>
</template>
<script>


export default {

  data() {
    return {
		
		id:'',
		images:[
		'https://img.yzcdn.cn/vant/apple-2.jpg',
		'https://img.yzcdn.cn/vant/apple-2.jpg',
		],
		ride:0,
		num: 1,
		info:'',
		news:[],
		notice:[],
		cart:false,
		roll:'',
		price:0
		
    
    };
  },  mounted() {
	  
	  this.id = this.$route.query.id;
	
		this.sandMate();
		this.sandCase();
		this.sandCart();
		},methods: {
			
			carou(e){
				this.ride=e
			},
			nood(index){
				this.$refs.carousel.setActiveItem(index)
			},
		handleChange(num,inventoryId){
			this.$axios({
			  method: "post",
			  url: "service.php?action=gouwuche_updateNum",
			  data: {inventoryId:inventoryId,num:num},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.sandCart()
				}
			 
			});
		},sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_detail",
				  data: {inventoryId:this.id},  
				}).then((res) => {
					let data=res.data;
				
					if(data.code==1){
						this.news=data.data;
					}
				 
				});
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},collect(it){
			
							if(window.localStorage.getItem('user')== "undefined"){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:it},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
									this.sandMate();
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
						})
						
					}
				 
				});
			},sandYart(){
				if(window.localStorage.getItem('user')== "undefined"){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.news.inventoryId,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						  this.cart=true;
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success("删除成功");
						
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			}
		}
};
</script>
<style lang="scss" scoped>
	.h-button{
		text-align: center;
		cursor: pointer;	
		padding: 0 50px;
		height: 50px;
		line-height: 50px;
		background: #000;
		color: #FFFFFF;
	}
	.h-button:hover{
		background-color: #333333;
	}
	.cart{
	
		background: #FFFFFF;
		.cart-tit{
			height: 70px;
			line-height: 70px;
			text-align: center;
		}
		.cart-con{
		
			 line-height: 100px;
			 text-align: center;
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-img{
			width: 100%;
		}
		.cart-bot{
		
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				justify-content: space-between;
			}
		}
	}
	.el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
	
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }

</style>